import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar, ShowVerticalScrollbar } from '../../../../global/commonStyle';

interface Props {
  isEdge?: boolean;
}
const DocumentBlock = styled.div<Props>`
  height: 100dvh;
  .editor {
    padding: var(--space-8);
    overflow: auto;
    height: calc(100dvh - 53px);
    max-height: max-content;
    /* .editorjs {
      max-width: 752px;
      padding: 38px 96px;
      margin: 0 auto;
    } */
    .ce-popover__items {
      ${ShowVerticalScrollbar}
    }
    .ce-inline-toolbar {
      background-color: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
      color: var(--text-primary) !important;
    }
    .ce-inline-tool:hover {
      background-color: var(--neutral-secondary) !important;
    }
    .ce-inline-toolbar__dropdown:hover {
      background-color: var(--neutral-secondary) !important;
      border-radius: var(--border-radius-6) var(--border-radius-0) var(--border-radius-0) var(--border-radius-6);
    }
    .ce-conversion-tool:hover {
      background: var(--neutral-secondary) !important;
    }
    .ce-conversion-tool--focused {
      background-color: var(--text-tertiary) !important;
    }
    .ce-conversion-toolbar--showed {
      background-color: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
      color: var(--text-primary) !important;
    }
    .tc-toolbox .tc-popover {
      background-color: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
      color: var(--text-primary) !important;
    }
    .ce-conversion-tool__icon {
      background-color: var(--background-primary) !important;
    }
    .ce-popover__item-icon {
      background: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
      box-shadow: none;
    }
    .codex-editor path {
      stroke: var(--text-primary) !important;
    }
    .codex-editor rect {
      stroke: var(--text-primary) !important;
    }
    .codex-editor line {
      stroke: var(--text-primary) !important;
    }
    .cdx-search-field__icon circle {
      stroke: var(--text-primary) !important;
    }
    .tc-toolbox__toggler svg rect {
      fill: var(--background-primary) !important;
    }
    .ce-paragraph {
      color: var(--text-primary) !important;
      ::selection {
        background-color: var(--text-tertiary) !important;
      }
    }
    .ce-block b::selection {
      background-color: var(--text-tertiary) !important;
    }
    .ce-block i {
      background-color: var(--text-tertiary) !important;
      ::selection {
        background-color: var(--text-tertiary) !important;
      }
    }
    .inline-code {
      color: var(--text-primary) !important;
      background: transparent;
      ::selection {
        background: var(--background-primary) !important;
      }
    }
    .ce-paragraph {
      span {
        background-color: var(--text-tertiary) !important;
      }
      mark::selection {
        background-color: var(--text-tertiary) !important;
      }
    }
    .cdx-marker {
      background-color: var(--text-tertiary) !important;
    }
    .ce-toolbar__plus {
      color: var(--text-primary) !important;
      &:hover {
        background-color: var(--neutral-secondary) !important;
      }
    }
    .ce-toolbar__settings-btn {
      color: var(--text-primary) !important;
    }
    .ce-toolbar__settings-btn:hover {
      background-color: var(--neutral-secondary) !important;
    }
    .ce-popover {
      border: 0.5px solid var(--border-primary);
      background-color: var(--background-secondary);
    }
    .ce-popover__item:hover:not(.ce-popover__item--no-visible-hover) {
      background-color: var(--neutral-secondary) !important;
    }
    .cdx-search-field {
      border: 0.5px solid var(--border-primary);
      background-color: var(--background-secondary);
    }
    .codex-editor__redactor {
      color: var(--text-primary) !important;
      padding-bottom: var(--space-0) !important ;
    }
    .ce-popover__item-label {
      color: var(--text-primary) !important;
    }
    .cdx-search-field__input {
      color: var(--text-primary) !important;
    }
    .tc-toolbox__toggler svg {
      fill: var(--text-primary) !important;
    }
    .tc-popover__item-icon {
      background: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
    }
    .tc-popover__item:hover {
      background-color: var(--neutral-secondary) !important;
    }
    .tc-row--selected:after {
      background: var(--background-primary) !important;
    }
    .tc-add-row:hover:before {
      background: var(--background-primary) !important;
    }
    .tc-add-column:hover,
    .tc-add-row:hover {
      background-color: var(--background-primary) !important;
    }
    .cdx-input {
      border: 0.5px solid var(--border-primary);
      ::selection {
        background: var(--text-tertiary) !important;
      }
    }
    h2.ce-header::selection {
      background-color: var(--text-tertiary) !important;
    }
    .ce-block__content::selection {
      background-color: var(--text-tertiary) !important;
    }
    .ce-block::selection {
      background-color: var(--text-tertiary) !important;
    }
    .ce-block--selected .ce-block__content {
      background-color: var(--background-primary) !important;
    }
    .tc-row--selected {
      background-color: var(--background-primary) !important;
    }
    .ce-rawtool__textarea {
      background-color: var(--background-primary) !important;
      color: var(--text-primary);
      ${Typography.body_lg_medium}
    }
    .cdx-button {
      background-color: var(--background-primary) !important;
      border: 0.5px solid var(--border-primary);
    }
    .ce-code__textarea {
      background-color: var(--background-primary) !important;
      color: var(--text-primary);
      ${Typography.body_lg_medium}
    }
    .cdx-checklist__item-checkbox-check {
      background-color: var(--background-primary) !important;
    }
    .cdx-checklist__item--checked .cdx-checklist__item-checkbox-check {
      border-color: var(--brand-primary);
    }
    .tc-cell--selected {
      background-color: var(--background-primary) !important;
    }
  }
  ${mobile_xl(css`
    .editor {
      padding: var(--space-0);
      margin: var(--space-0) -16px;
    }
  `)}

  .docs-section {
    border-width: 0;
    ${HideScrollbar}
    height: calc(100dvh - 57px);
  }
`;

const DocumentHeader = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  padding: var(--space-10) var(--space-24) var(--space-10) var(--space-12);
  position: sticky;
  z-index: var(--z-index-header);
  top: 0;
  background-color: var(--background-secondary);
  border-bottom: 0.5px solid var(--border-primary);
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-6);
    svg path {
      fill: var(--text-primary);
    }
  }
  ${mobile_xl(css`
    padding: var(--space-12) var(--space-20);
  `)}
`;

const DocumentForm = styled.form`
  color: var(--text-secondary);
  padding: var(--space-4);
  ${Typography.body_lg}
  padding-right: var(--space-12);
`;

const DocumentButton = styled.div`
  display: flex;
  gap: var(--space-10);
`;

const LeftDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
`;

const AvatarDiv = styled.div`
  display: flex;
`;
const ButtonDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;
const RightDiv = styled.div`
  display: flex;
  li {
    list-style: none;
    margin-right: -8px;
  }
`;

const DropDiv = styled.div`
  min-width: 198px;
`;

const EditorContainer = styled.div<Props>`
  padding: ${({ isEdge }) => (isEdge ? 'var(--space-0)' : 'var(--space-0) var(--space-8)')};
`;

export {
  DocumentBlock,
  DocumentHeader,
  DocumentForm,
  DocumentButton,
  LeftDiv,
  RightDiv,
  AvatarDiv,
  ButtonDiv,
  DropDiv,
  EditorContainer
};
